import { get } from 'lodash';
import { SIGNOUT } from 'Store/user-info/actions/signout';
import { SYNC_WITH_LOCATION } from 'Store/constants';
import { QUERY_TRANSPORT } from 'Utils/uri/constants';
import { TRIP_INFORMATION_SET_DEPARTURE_CITY, DEFAULT_DEPARTURE_CITY } from './constants';
type State = string;
const initialState = null;

function departureCityReducer(
  state: State | null | undefined = initialState,
  action: Action<any> | null | undefined,
): State | null | undefined {
  switch (get(action, 'type')) {
    case SYNC_WITH_LOCATION:
      const { payload: { location: { queryParams } } = {} } = action || {};
      // in cases where params is not in the url, we should just keep the state as it is.
      return queryParams[QUERY_TRANSPORT] ? queryParams[QUERY_TRANSPORT] : state;

    case TRIP_INFORMATION_SET_DEPARTURE_CITY:
      return get(action, 'payload.value', DEFAULT_DEPARTURE_CITY);

    case SIGNOUT:
      return initialState;

    default:
      return state;
  }
}

export default departureCityReducer;
